import {
  AUDIT_ARO_HREF,
  AUDIT_CRO_HREF,
  HOMEPAGE_PREVIEW_ARO_TITLE,
  HOMEPAGE_PREVIEW_CRO_TITLE,
  HOMEPAGE_PREVIEW_SAMPLE_LABEL,
  RESULTS_AGENTS_LABEL,
  RESULTS_OPPORTUNITY,
  RESULTS_PEOPLE_LABEL,
} from "~/lib/siteglue/landing-redesign/copy";

export const HOMEPAGE_PREVIEW_INTERVAL_MS = 6000;

export type HomepagePreviewSlideId = "aro" | "cro";

export type HomepagePreviewRow = {
  id: string;
  label: string;
  score: number;
  result: "Verified" | typeof RESULTS_OPPORTUNITY;
};

export type HomepagePreviewSlide = {
  id: HomepagePreviewSlideId;
  kicker: string;
  href: string;
  title: string;
  scoreLabel: string;
  score: number;
  summary: string;
  rows: readonly HomepagePreviewRow[];
};

const SLIDE_ORDER: readonly HomepagePreviewSlideId[] = ["aro", "cro"];

export const HOMEPAGE_PREVIEW_SLIDES: readonly HomepagePreviewSlide[] = [
  {
    id: "aro",
    kicker: HOMEPAGE_PREVIEW_ARO_TITLE,
    href: AUDIT_ARO_HREF,
    title: RESULTS_AGENTS_LABEL,
    scoreLabel: "ARO Score",
    score: 72,
    summary: "Discovery, structured knowledge, MCP connectivity, and agent actions.",
    rows: [
      { id: "discovery", label: "Discovery and crawlability", score: 88, result: "Verified" },
      { id: "knowledge", label: "Structured business knowledge", score: 76, result: "Verified" },
      { id: "mcp", label: "MCP and agent connectivity", score: 41, result: RESULTS_OPPORTUNITY },
      { id: "actions", label: "Agent-compatible tools and actions", score: 38, result: RESULTS_OPPORTUNITY },
    ],
  },
  {
    id: "cro",
    kicker: HOMEPAGE_PREVIEW_CRO_TITLE,
    href: AUDIT_CRO_HREF,
    title: RESULTS_PEOPLE_LABEL,
    scoreLabel: "CRO Score",
    score: 81,
    summary: "First impression, CTAs, trust, mobile, and conversion flow across your channels.",
    rows: [
      { id: "first", label: "First impression", score: 86, result: "Verified" },
      { id: "cta", label: "CTA effectiveness", score: 79, result: "Verified" },
      { id: "trust", label: "Trust signals", score: 74, result: "Verified" },
      { id: "flow", label: "Conversion flow", score: 41, result: RESULTS_OPPORTUNITY },
    ],
  },
] as const;

export function nextHomepagePreviewSlide(current: HomepagePreviewSlideId): HomepagePreviewSlideId {
  const index = SLIDE_ORDER.indexOf(current);
  return SLIDE_ORDER[(index + 1) % SLIDE_ORDER.length] ?? "aro";
}

export function previousHomepagePreviewSlide(current: HomepagePreviewSlideId): HomepagePreviewSlideId {
  const index = SLIDE_ORDER.indexOf(current);
  return SLIDE_ORDER[(index - 1 + SLIDE_ORDER.length) % SLIDE_ORDER.length] ?? "aro";
}

export function homepagePreviewShouldAutoplay(options: {
  reducedMotion: boolean;
  paused: boolean;
  pageVisible: boolean;
}): boolean {
  return !options.reducedMotion && !options.paused && options.pageVisible;
}

export function homepagePreviewSampleLabel(): string {
  return HOMEPAGE_PREVIEW_SAMPLE_LABEL;
}
